import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { MbConstants } from '../../../../shared/mb-constants'
import { JobTitle } from '../../../../models'

@Component({
  selector: 'mb-checkout-job-title-form-partial',
  templateUrl: './mb-checkout-job-title-form-partial.component.html',
})
export class MbCheckoutJobTitleFormPartialComponent {

  constants = MbConstants
  @Input() formGroup: UntypedFormGroup | undefined
  @Input() jobTitles: JobTitle[] | undefined
  @Input() roleLabelKey = 'contact.role'
  @Input() selectedRole: JobTitle = { code: this.constants.ROLE, name: this.roleLabelKey }
  @Input() isFormDisabled = false

  onJobTitleChange (value: JobTitle) {
    this.selectedRole = value
    this.formGroup?.patchValue({ jobTitle: value })
  }
}
